<template>
  <input
    ref="inputElement"
    v-model="value"
    v-bind="$attrs"
    class="w-full min-w-0 max-w-[min(100%,35rem)] rounded-md border border-transparent bg-lightSecondaryColor pl-xs text-lightSecondaryTextColor shadow-inner outline-none focus:!border-primary disabled:cursor-not-allowed disabled:text-lightTertiaryColor disabled:shadow-none dark:border-darkSecondaryColor dark:bg-neutral-900 dark:text-darkSecondaryTextColor disabled:dark:bg-darkPrimaryColor dark:disabled:text-darkTertiaryColor"
    :class="{
      '!border-red': errors,
      'isInTabsComponent:!bg-lightPrimaryColor dark:isInTabsComponent:!bg-neutral-900': true,
    }"
    @input="clearErrors"
  />
</template>

<script setup lang="ts">
import { InputHTMLAttributes, Ref, ref } from "vue";

import { watch } from "vue";
import { useErrors } from "../errors/useErrors";

interface Props extends /* @vue-ignore */ InputHTMLAttributes {
  emptyValue?: null | string;
}
const props = defineProps<Props>();
const value = defineModel<null | undefined | number | string>();

const { errors, clearErrors } = useErrors();

const inputElement: Ref<null | HTMLInputElement> = ref(null);

defineExpose({
  focus: () => {
    inputElement.value?.focus();
  },
  inputElement,
});

if (props.emptyValue !== undefined) {
  watch(value, (newValue) => {
    if (typeof newValue === "string" && newValue === "") {
      value.value = props.emptyValue;
    }
  });
}
</script>
